import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6d1f1f92"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "main"
};
var _hoisted_2 = {
  class: "center"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "隐私政策", -1);
});

var _hoisted_4 = {
  class: "neirou"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", null, "服务条款/隐私条款及法律声明", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    style: {
      "margin-bottom": "50px",
      "color": "#707070"
    }
  }, "本声明适用于您使用跬步磐石所提供的各种资讯、会议和服务(以下简称\"服务\")。", -1);
});

var _hoisted_7 = {
  class: "hgao"
};

var _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>1.服务条款的确认和接纳</p><p data-v-6d1f1f92>跬步磐石同意按照本协议的规定提供基于互联网的相关服务（以下简称：网络服务），网络服务的所有权、运作权和解释权归跬步磐石拥有。 为获得网络服务，用户在浏览跬步磐石时即表示完全接受本协议项下的全部条款。</p></div><div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>2.跬步磐石网络技术服务内容</p><p data-v-6d1f1f92>2.1.跬步磐石通过互联网为用户提供新闻、文库、视频、会展、会议、企业&amp;机构、产品等，具体内容由跬步磐石根据实际情况提供。跬步磐石推出的网络服务针对不同级别的用户有所区别，在针对不同级别的用户提供网络服务时，会对部分网络服务收取一定的费用。在此情况下，跬步磐石会在相关页面上做明确的提示。如用户拒绝支付该项费用，则不能使用相关的网络服务内容。</p><p data-v-6d1f1f92>2.2.跬步磐石仅提供相关的网络服务，用户必须自行负担以下的设备及费用：</p><p data-v-6d1f1f92>2.2.1.相关网络服务设备，如个人电脑、调制解调器及其他与接入互联网有关的装置。 </p><p data-v-6d1f1f92>2.2.2.为接入互联网而支付的电话费及上网费。</p></div><div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>3.服务变更、中断及终止</p><p data-v-6d1f1f92>3.1.鉴于网络服务的特殊性，用户同意跬步磐石有权随时变更、中断或终止部分或全部的网络服务（包括收费网络服务）。如变更、中断或终止的网络服务属于免费网络服务，跬步磐石无需通知用户，也无需对任何用户或任何第三方承担任何责任；如变更、中断或终止的网络服务属于收费网络服务，跬步磐石应当在变更、中断或终止之前事先通知用户，并应向受影响的用户提供等值的替代性的收费网络服务，如用户不愿意接受替代性的收费网络服务，跬步磐石应当按照该用户实际使用相应收费网络服务的情况扣除相应服务费之后将剩余的服务费退还给该用户。</p><p data-v-6d1f1f92>3.2.如因系统维护或升级的需要而需暂停网络服务造成收费网络服务在合理时间内的中断，跬步磐石无需为此承担任何责任，但跬步磐石将尽可能事先进行通告。</p><p data-v-6d1f1f92>3.3.如发生下列任何一种情形，跬步磐石有权随时中断或终止向用户提供本协议项下的网络服务而无需通知用户：</p><p data-v-6d1f1f92>3.3.1.用户提供的个人资料不真实</p><p data-v-6d1f1f92>3.3.2.用户违反本协议中规定的用户规则；</p><p data-v-6d1f1f92>3.3.3.用户在使用收费网络服务时未按规定向跬步磐石支付相应的服务费。</p></div>", 3);

var _hoisted_11 = {
  style: {
    "margin-bottom": "40px"
  }
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    style: {
      "margin-bottom": "15px"
    }
  }, "4.用户规则：", -1);
});

var _hoisted_13 = {
  style: {
    "margin-bottom": "40px"
  }
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    style: {
      "margin-bottom": "15px"
    }
  }, "5.用户隐私制度", -1);
});

var _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>6.免责声明</p><p data-v-6d1f1f92>6.1.用户明确同意其使用跬步磐石网络服务所存在的风险将完全由其自己承担；因其使用跬步磐石网络服务而产生的一切后果也由其自己承担，跬步磐石对用户不承担任何责任。 </p><p data-v-6d1f1f92>6.2.跬步磐石不作任何类型的担保，不担保服务一定能满足用户的要求，也不担保服务不会受中断，对服务的及时性，安全性，出错发生都不作担保。用户理解并接受：任何通过跬步磐石服务取得的信息资料的可靠性取决于用户自己，用户自己承担所有风险和责任。 </p><p data-v-6d1f1f92>6.3.跬步磐石不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由跬步磐石实际控制的任何网页上的内容，跬步磐石不承担任何责任。</p><p data-v-6d1f1f92>6.4.对于因不可抗力或跬步磐石不能控制的原因造成的网络服务中断或其它缺陷，跬步磐石不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。</p><p data-v-6d1f1f92>6.5.用户同意，对于跬步磐石向用户提供的下列产品或者服务的质量缺陷本身及其引发的任何损失，跬步磐石无需承担任何责任；</p><p data-v-6d1f1f92>6.5.1.跬步磐石向用户免费提供的各项网络服务；</p><p data-v-6d1f1f92>6.5.2.跬步磐石向用户赠送的任何产品或者服务；</p><p data-v-6d1f1f92>6.5.3.跬步磐石向收费网络服务用户附赠的各种产品或者服务。</p></div><div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>7.网站内容的所有权</p><p data-v-6d1f1f92>跬步磐石定义的内容包括但不限于文字、软件、声音、相片、图片、录像、图表、数据库；在广告中的全部内容；电子邮件的全部内容；跬步磐石为用户提供的商业信息。所有这些内容受版权、商标、标签和其它财产所有权法律的保护。用户只能在跬步磐石和广告商授权下才能使用这些内容，而不能擅自复制、篡改这些内容、或创造与内容有关的派生产品。</p></div><div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>8.附加信息服务</p><p data-v-6d1f1f92>8.1用户在享用跬步磐石提供的免费与收费服务的同时，同意接受跬步磐石提供的各类附加信息服务，附加信息服务包括但不限于跬步磐石向用户提供的邮件、短信、电话信息等。</p><p data-v-6d1f1f92>8.2用户有直接向跬步磐石申请取消附加信息服务的权利，双方通过友好协商方式解决，但用户不得以未通知跬步磐石前提下向第三方投诉或诉讼，如因此引起的跬步磐石经济及名誉损失，我方保留法律诉讼权利。</p></div><div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>9.协议修改</p><p data-v-6d1f1f92>9.1.跬步磐石有权随时修改本协议的任何条款，一旦本协议的内容发生变动，跬步磐石将会直接在跬步磐石网站上公布修改之后的协议内容，该公布行为视为跬步磐石已经通知用户修改内容。跬步磐石也可通过其他适当方式向用户提示修改内容。</p><p data-v-6d1f1f92>9.2.如果不同意跬步磐石对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受跬步磐石对本协议相关条款所做的修改。</p></div><div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>10.通知送达</p><p data-v-6d1f1f92>10.1.本协议项下跬步磐石对于用户所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p><p data-v-6d1f1f92>10.2.用户对于跬步磐石的通知应当通过跬步磐石对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p></div><div style=\"margin-bottom:40px;\" data-v-6d1f1f92><p style=\"margin-bottom:15px;\" data-v-6d1f1f92>11.其他规定</p><p data-v-6d1f1f92>11.1.本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p><p data-v-6d1f1f92>11.2.如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p></div>", 6);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", null, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_11, [_hoisted_12, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Data1, function (item, index) {
    return _openBlock(), _createElementBlock("p", {
      key: index
    }, _toDisplayString(item), 1);
  }), 128))]), _createElementVNode("div", _hoisted_13, [_hoisted_14, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.data2, function (item, index) {
    return _openBlock(), _createElementBlock("p", {
      key: index
    }, _toDisplayString(item), 1);
  }), 128))]), _hoisted_15])])])])]);
}